
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[post]",
      function () {
        return require("private-next-pages/blog/[post].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[post]"])
      });
    }
  